import { UploadCSV } from '@bo-components/common/UploadCSVBase';
import { useUploadPlayersByCSVMutation } from '@bo-services/playersApi';

export const UploadNewPlayerCSV = () => {
  const [
    uploadPlayersByCSV,
    { error, isError, isLoading, isSuccess, isUninitialized, reset }
  ] = useUploadPlayersByCSVMutation();

  const handleFileUpload = async (uploadFile: File | null) => {
    if (!uploadFile) {
      return;
    }

    const formData = new FormData();
    formData.append('csv', uploadFile);

    await uploadPlayersByCSV(formData).catch(() => {});
  };

  return (
    <UploadCSV
      buttonText="Import CSV"
      handleFileUpload={handleFileUpload}
      error={error}
      isError={isError}
      isLoading={isLoading}
      isSuccess={isSuccess}
      isUninitialized={isUninitialized}
      reset={reset}
    />
  );
};
